import _ from 'lodash'

export const FilterTable = {
  data () {
    return {
      filters: {

      },
      searchQuery: ''
    }
  },

  methods: {
    search () {
      this.$refs.table.addParam('q', this.searchQuery)
      this.$refs.table.updateTable()
    },

    filter () {
      _.each(this.filters, (filter, key) => {
       // let values = _.map(filter, 'value')

        this.$refs.table.addParam(key,this.filters[key])
      })

      if(this.searchQuery && this.searchQuery!='')
      {
        this.$refs.table.addParam('q', this.searchQuery)
      }
     

      this.$refs.table.updateTable()
    },

    filterClear () {
      this.searchQuery = ''
      this.$refs.table.addParam('q', this.searchQuery)

      Object.keys(this.filters).forEach((filter) => {
        this.$refs.table.addParam(filter, null)
        this.$set(this.filters, filter, null)
      })

      if (this.clearInputs)
        this.clearInputs()

      this.$refs.table.clearFilters()
    }
  }
}
